import { motion } from "framer-motion";

export const ElectricCard = ({ children, className = "", delayClass = "", testId, ...props }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 36 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      data-testid={testId}
      className={`electric-card ${delayClass} rounded-2xl bg-black/50 backdrop-blur-xl border border-white/10 ${className}`}
      {...props}
    >
      {children}
    </motion.div>
  );
};
